'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 *
 */
var OPEN = exports.OPEN = 'vtech-chat/socket/OPEN';
var OPENED = exports.OPENED = 'vtech-chat/socket/OPENED';
var CLOSE = exports.CLOSE = 'vtech-chat/socket/CLOSE';
var CLOSED = exports.CLOSED = 'vtech-chat/socket/CLOSED';
var SET_SESSION = exports.SET_SESSION = 'vtech-chat/socket/SET_SESSION';
var DISPATCH_ON_OPENING = exports.DISPATCH_ON_OPENING = 'vtech-chat/socket/DISPATCH_ON_OPENING';
var QUEUE_ACTION = exports.QUEUE_ACTION = 'vtech-chat/socket/QUEUE_ACTION';
var CLEAR_ACTION_QUEUE = exports.CLEAR_ACTION_QUEUE = 'vtech-chat/socket/CLEAR_ACTION_QUEUE';
var CALL = exports.CALL = 'vtech-chat/socket/CALL';
var PUBLISH = exports.PUBLISH = 'vtech-chat/socket/PUBLISH';
var SUBSCRIBE = exports.SUBSCRIBE = 'vtech-chat/socket/SUBSCRIBE';

/**
 *
 */
var open = exports.open = function open(url) {
	return {
		type: OPEN,
		payload: {
			url: url
		}
	};
};

/**
 *
 */
var opened = exports.opened = function opened(session) {
	return {
		type: OPENED,
		payload: {
			session: session
		}
	};
};

/**
 *
 */
var close = exports.close = function close() {
	return {
		type: CLOSE,
		payload: {}
	};
};

/**
 *
 */
var closed = exports.closed = function closed(reason, details) {
	return {
		type: CLOSED,
		payload: {
			reason: reason,
			details: details
		}
	};
};

/**
 *
 */
var setSession = exports.setSession = function setSession(session) {
	return {
		type: SET_SESSION,
		payload: {
			session: session
		}
	};
};

/**
 *
 */
var dispatchOnOpening = exports.dispatchOnOpening = function dispatchOnOpening(action) {
	return {
		type: DISPATCH_ON_OPENING,
		payload: {
			action: action
		}
	};
};

/**
 *
 */
var queueAction = exports.queueAction = function queueAction(action) {
	return {
		type: QUEUE_ACTION,
		payload: {
			action: action
		}
	};
};

/**
 *
 */
var clearActionQueue = exports.clearActionQueue = function clearActionQueue() {
	return {
		type: CLEAR_ACTION_QUEUE,
		payload: {}
	};
};

/**
 *
 */
var call = exports.call = function call(uri, actionCreator) {
	var data = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	return {
		type: CALL,
		meta: {
			uri: uri,
			actionCreator: actionCreator
		},
		payload: data
	};
};

/**
 *
 */
var publish = exports.publish = function publish(channel, type) {
	var data = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	return {
		type: PUBLISH,
		meta: {
			channel: channel
		},
		payload: {
			type: type,
			data: data
		}
	};
};

/**
 *
 */
var subscribe = exports.subscribe = function subscribe(channel, actionCreator) {
	return {
		type: SUBSCRIBE,
		meta: {
			channel: channel,
			actionCreator: actionCreator
		},
		payload: {}
	};
};